/**
 * WP Swiper Plugin - Centered Display Slider
 * Version: 1.0.0
 */

(function($) {
    'use strict';
    
    var WPSwiperCentered = {
        
        init: function() {
            $(window).on('elementor/frontend/init', this.onElementorFrontendInit.bind(this));
            
            if (typeof elementorFrontend === 'undefined') {
                $(document).ready(this.initSwipers.bind(this));
            }
        },
        
        onElementorFrontendInit: function() {
            elementorFrontend.hooks.addAction('frontend/element_ready/centered_display_slider.default', this.initWidget.bind(this));
        },
        
        initWidget: function($scope) {
            var $swiperContainer = $scope.find('.wp-swiper-centered');
            if ($swiperContainer.length) {
                this.createSwiper($swiperContainer, $scope);
            }
        },
        
        initSwipers: function() {
            $('.wp-swiper-centered-wrapper').each(function() {
                var $wrapper = $(this);
                var $swiperContainer = $wrapper.find('.wp-swiper-centered');
                if ($swiperContainer.length) {
                    WPSwiperCentered.createSwiper($swiperContainer, $wrapper);
                }
            });
        },
        
        createSwiper: function($container, $wrapper) {
            if ($container.length === 0) {
                return;
            }
            
            var config = $container.data('swiper-config') || {};
            
            // 手动复制 slides 以满足 loop + centeredSlides 的要求
            var $slides = $container.find('.swiper-slide');
            var originalCount = $slides.length;
            var targetCount = 8; // 目标 slides 数量
            
            if (originalCount < targetCount) {
                var $swiperWrapper = $container.find('.swiper-wrapper');
                var neededClones = Math.ceil((targetCount - originalCount) / originalCount);
                for (var i = 0; i < neededClones; i++) {
                    $slides.each(function() {
                        $swiperWrapper.append($(this).clone());
                    });
                }
            }
            
            var defaultConfig = {
                loop: true,
                spaceBetween: config.spaceBetween || 20,
                slidesPerView: 2,
                centeredSlides: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 12
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: config.spaceBetween || 20
                    }
                }
            };
            
            // 自动播放
            if (config.autoplay) {
                defaultConfig.autoplay = config.autoplay;
            }
            
            // 导航
            var $prevBtn = $wrapper.find('.swiper-button-prev');
            var $nextBtn = $wrapper.find('.swiper-button-next');
            if ($prevBtn.length && $nextBtn.length) {
                defaultConfig.navigation = {
                    prevEl: $prevBtn[0],
                    nextEl: $nextBtn[0]
                };
            }
            
            // 分页
            var $pagination = $wrapper.find('.swiper-pagination');
            if ($pagination.length) {
                defaultConfig.pagination = {
                    el: $pagination[0],
                    clickable: true
                };
            }
            
            try {
                var swiper = new Swiper($container[0], defaultConfig);
                $container.data('swiper-instance', swiper);
                
                // 调试
                console.log('=== Swiper 初始化成功 ===');
                console.log('配置:', defaultConfig);
                console.log('slides 总数:', swiper.slides.length);
                console.log('复制的 slides:', $container.find('.swiper-slide-duplicate').length);
                
                // 更新页码 - 使用原始数量
                var $fraction = $wrapper.find('.swiper-fraction');
                if ($fraction.length) {
                    $fraction.find('.total').text(originalCount);
                    swiper.on('slideChange', function() {
                        var currentIndex = (swiper.realIndex % originalCount) + 1;
                        $fraction.find('.current').text(currentIndex);
                    });
                }
                
            } catch (error) {
                console.error('WP Swiper Plugin: Error initializing centered swiper', error);
            }
        },
        
        destroySwiper: function($container) {
            var swiper = $container.data('swiper-instance');
            if (swiper && swiper.destroy) {
                swiper.destroy(true, true);
                $container.removeData('swiper-instance');
            }
        }
    };
    
    WPSwiperCentered.init();
    
    window.WPSwiperCentered = WPSwiperCentered;
    
})(jQuery);
